import { useId } from 'react';
import { FormControlLabel, FormHelperText, Grid, Typography } from '@mui/material';
import { getIn } from 'formik';

import { FHRadio, FHRadioGroup } from '../../../components/base';
import { FORTA_ERROR } from '../../../utils/colors';

import type { ChangeEvent } from 'react';
import type { RequiresEvvFieldProps, RequiresEvvFormValues } from './types';

export default function RequiresEvvField<TValues extends RequiresEvvFormValues>({
  formik,
}: RequiresEvvFieldProps<TValues>) {
  const labelId = useId();
  const helperTextId = useId();
  const errorMessage = getIn(formik.touched, 'evv_required')
    ? getIn(formik.errors, 'evv_required')
    : undefined;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue('evv_required', event.target.value === 'true');
  };

  return (
    <Grid container p={0.5} spacing={1} display={'flex'} alignItems={'center'}>
      <Grid item xs={2.5}>
        <Typography id={labelId} textAlign={'left'}>
          Requires EVV:
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <FHRadioGroup
          row
          rowGap="0"
          name="evv_required"
          aria-labelledby={labelId}
          aria-describedby={errorMessage ? helperTextId : undefined}
          value={String(getIn(formik.values, 'evv_required'))}
          onChange={handleChange}
          sx={{ columnGap: 3 }}
        >
          <FormControlLabel value="true" control={<FHRadio />} label="Yes" />
          <FormControlLabel value="false" control={<FHRadio />} label="No" />
        </FHRadioGroup>
        {errorMessage && (
          <FormHelperText id={helperTextId} sx={{ color: FORTA_ERROR, fontSize: '0.75rem' }}>
            {errorMessage}
          </FormHelperText>
        )}
      </Grid>
    </Grid>
  );
}
